import React, { useState } from 'react';
import { useNavigation } from '../Navigation/NavigationContext';
import { DemoSettings } from '../../types/navigation';
import './DemoControls.css';

const DemoControls: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { state, updateDemoSettings } = useNavigation();

  const handleSettingChange = (setting: keyof DemoSettings, value: boolean) => {
    updateDemoSettings({ [setting]: value });
  };

  return (
    <div className="demo-controls">
      <button
        className={`demo-fab ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle demo controls"
      >
        {isOpen ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1"></path>
          </svg>
        )}
      </button>

      {isOpen && (
        <div className="demo-panel">
          <div className="demo-panel-header">
            <h3>Demo Controls</h3>
            <p>Adjust navigation layout and behavior</p>
          </div>
          
          <div className="demo-panel-content">
            <div className="demo-control-group">
              <h4>Navigation Layout</h4>
              <label className="demo-checkbox">
                <input
                  type="checkbox"
                  checked={state.demoSettings.productsAboveNav}
                  onChange={(e) => handleSettingChange('productsAboveNav', e.target.checked)}
                />
                <span className="demo-checkbox-indicator"></span>
                Products bar above site navigation
              </label>
            </div>

            <div className="demo-control-group">
              <h4>Visual Enhancements</h4>
              <label className="demo-checkbox">
                <input
                  type="checkbox"
                  checked={state.demoSettings.showProductLogos}
                  onChange={(e) => handleSettingChange('showProductLogos', e.target.checked)}
                />
                <span className="demo-checkbox-indicator"></span>
                Show product logos in sub-navigation
              </label>
              
              <label className="demo-checkbox">
                <input
                  type="checkbox"
                  checked={state.demoSettings.hoverEffects}
                  onChange={(e) => handleSettingChange('hoverEffects', e.target.checked)}
                />
                <span className="demo-checkbox-indicator"></span>
                Enhanced hover effects
              </label>
              
              <label className="demo-checkbox">
                <input
                  type="checkbox"
                  checked={state.demoSettings.activeStates}
                  onChange={(e) => handleSettingChange('activeStates', e.target.checked)}
                />
                <span className="demo-checkbox-indicator"></span>
                Persistent active states
              </label>
            </div>

            <div className="demo-control-group">
              <h4>Current State</h4>
              <div className="demo-state-info">
                <div className="demo-state-item">
                  <span className="demo-state-label">Section:</span>
                  <span className="demo-state-value">{state.section}</span>
                </div>
                <div className="demo-state-item">
                  <span className="demo-state-label">Product:</span>
                  <span className="demo-state-value">{state.product || 'None'}</span>
                </div>
                <div className="demo-state-item">
                  <span className="demo-state-label">Page:</span>
                  <span className="demo-state-value">{state.page || 'None'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoControls;